import React from "react";

export type useInfiniteScrollArgs = {
  scrollElement: HTMLElement | null;
  onScrollLimitReached: () => void;
};

export const useInfiniteScroll = (scrollArgs: useInfiniteScrollArgs) => {
  const [scrollPosition, setScrollPosition] = React.useState(window.pageYOffset);

  const trackScrollPosition = React.useCallback(async () => {
    let scrollPosition: number = 992;
    scrollPosition += scrollArgs.scrollElement?.scrollTop || 0;
    setScrollPosition(scrollPosition);
    const clientHeightOffset = (scrollArgs.scrollElement?.scrollHeight || 99999) * 0.9;
    if (clientHeightOffset < scrollPosition) {
      scrollArgs.onScrollLimitReached();
    }
  }, [scrollArgs]);

  React.useEffect(() => {
    scrollArgs.scrollElement?.addEventListener("scroll", trackScrollPosition, { passive: true });
    return () => {
      scrollArgs?.scrollElement?.removeEventListener("scroll", trackScrollPosition);
    };
  }, [scrollArgs, scrollArgs.scrollElement, trackScrollPosition]);
  return {
    scrollPosition,
  };
};
